import trigger from './customEvent';

//タイムラインを生成
export default class MyTimeline {

  constructor(wrapElId) {
		this.calObj = {};
		this.cal    = {};
		this.range  = null;
		this.isSelected = false;
		this.wrapEl = document.getElementById(wrapElId);
		this.selectedFData = { "start": {}, "end" : {} };
		this.paramYear;
		this.paramMonth;
		this.dataNextYear;
		this.dataNextMonth;
		this.dataPrevYear;
		this.dataPrevMonth;
		this.count = 0;
	}

  getElement() {
    return this.wrapEl;
  }

  getCurrentYear() {
		let y = (this.paramYear < 10)? "0"+this.paramYear : this.paramYear;
    return y;
  }

  getCurrentMonth() {
		let m = (this.paramMonth < 10)? "0"+this.paramMonth : this.paramMonth;
    return m;
  }

	getPrevDate() {
		const dt = new Date(this.dataPrevYear, this.dataPrevMonth - 1, 1);
		dt.setMonth(dt.getMonth() - 1);
		return {
			year: dt.getFullYear(),
			month: dt.getMonth() + 1
		};
	}

	getNextDate() {
		const dt = new Date(this.dataNextYear, this.dataNextMonth - 1, 1);
		dt.setMonth(dt.getMonth() + 1);
		return {
			year: dt.getFullYear(),
			month: dt.getMonth() + 1
		};
	}

	currentYear() {
		let cy = {};
		cy.date = new Date();
		cy.month = cy.date.getFullYear() ;
		return cy.month;
	}

	currentMonth() {
		let cm = {};
		cm.date = new Date();
		cm.month = cm.date.getMonth() + 1;
		return cm.month;
	}

	generate(dispYear, dispMonth, distance) {

		trigger(window, 'loadingStart');

		if(!dispYear) {
			dispYear = this.currentYear();
		}
		if(!dispMonth) {
			dispMonth = this.currentMonth();
		}

		if(!distance) {
			this.dataPrevYear = dispYear;
			this.dataPrevMonth = dispMonth;
			this.dataNextYear = dispYear;
			this.dataNextMonth = dispMonth;
		}
		if(distance == 'next') {
			this.dataNextYear = dispYear;
			this.dataNextMonth = dispMonth;
		}
		if(distance == 'prev') {
			this.dataPrevYear = dispYear;
			this.dataPrevMonth = dispMonth;
		}

		this.paramYear = dispYear;
		this.paramMonth = dispMonth;
		//カレンダーデータ
		let week = ["日","月","火","水","木","金","土"];
		// let week = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
		let monthdays = [0,31,28,31,30,31,30,31,31,30,31,30,31];
		let date = new Date();
		let year =  date.getFullYear();
		let month = date.getMonth() + 1;
		let day = date.getDay();
		let today = date.getDate();
		let wi = 0;//日にちセル生成ループ変数
		let daytext = 1;//日にちの数字
		let date2 = new Date(1);
		//うるう年
		if((dispYear%4==0)&&(dispYear%100!=0)||(dispYear%400==0)){
			monthdays[2] = 29;
		}
		let currentMonthDays = monthdays[dispMonth];
		//HTML
		let div = document.createElement("div");
		    div.className = "c-timeline__main";
		let wrapel = document.createElement("div");
		let headel = document.createElement("div");
		let bodyel = document.createElement("ul");
		bodyel.className = "c-timelime__list js-timelime__list";
		bodyel.id = "js-timelime-list-" + this.count;
		//月とナビの生成
		let unit = document.createElement("div");
		    unit.className = "my-timelime-unit";

		let head = document.createElement("p");
		head.className = "my-timelime-head u-screen-reader";
		let headMonth = document.createElement("b");
		let mth = (dispMonth < 10)? "0"+dispMonth : dispMonth;
		let headtxt = document.createTextNode(dispYear+'年');
		let headMonthTxt = document.createTextNode(mth+'月');

		date2.setFullYear(dispYear);
		date2.setMonth(dispMonth - 1);
		date2.setDate(1);
		headMonth.appendChild(headMonthTxt);
		head.appendChild(headtxt);
		head.appendChild(headMonth);
		unit.appendChild(head);
		div.appendChild(unit);

		//日にちセルを生成
		for(wi=0;wi<date2.getDay();wi+=1){
			//1日の曜日を正しい位置に移動するため空のループを回す
		}
		let ctoday = today;
		let daysI;
		for(daysI=wi; daysI<(currentMonthDays + wi); daysI+=1){
			let td = document.createElement("li");
			let mdaytxt = (daytext < 10)? "0"+daytext : daytext;
			const mydateStr = dispYear+''+mth+''+mdaytxt;
			td.setAttribute('data-id', 'date-'+mydateStr);
			td.setAttribute('id', 'd-'+dispYear+'-'+mth+'-'+mdaytxt);
			let span = document.createElement("span");
			span.className = 'c-timeline__day';
			const div1 = document.createElement("div");
			div1.className = "c-timeline__item is-kayanoya js-timeline-item js-recipe-unit";
			div1.setAttribute('id', 'kr_kayanoya-'+mydateStr);
			const div1in = document.createElement("div");
			div1in.className = 'inner';
			div1.appendChild(div1in);
			const div2 = document.createElement("div");
			const div2in = document.createElement("div");
			div2in.className = 'inner';
			div2.className = "c-timeline__item is-yasai js-timeline-item js-recipe-unit";
			div2.setAttribute('id', 'kr_yasai-'+mydateStr);
			div2.appendChild(div2in);
			if(daytext == ctoday && dispMonth == month && dispYear == year){
				span.classList.add("is-today");
			}else if(daysI%7 === 0){
				span.classList.add("is-sun");
			}else if(daysI%7 === 6){
				span.classList.add("is-sat");
			};

			const myweekN = daysI % 7;
			let day = '<span class="is-y">'+dispYear+'年</span> <span class="is-m">'+dispMonth+'月</span><span class="is-d">'+daytext+'日</span><span class="is-w">（'+week[myweekN]+'）</span>';

			daytext += 1;
			td.appendChild(span);
			td.appendChild(div1);
			td.appendChild(div2);
			span.innerHTML = day;
			bodyel.prepend(td);
		}

		wrapel.appendChild(headel);
		wrapel.appendChild(bodyel);
		div.appendChild(wrapel);

		this.count += 1;

		return div;
	}

	create(dispYear, dispMonth) {
		const div = this.generate(dispYear, dispMonth, null)
		this.wrapEl.appendChild(div);
		trigger(this.wrapEl, 'created', {el:div});
	}

	addTop(dispYear, dispMonth) {
		const div = this.generate(dispYear, dispMonth, 'next')
		this.wrapEl.prepend(div);
		trigger(this.wrapEl, 'addedTop', {el:div});
	}

	addBottom(dispYear, dispMonth) {
		const div = this.generate(dispYear, dispMonth, 'prev')
		this.wrapEl.appendChild(div);
		trigger(this.wrapEl, 'addedBottom', {el:div});
	}

}
